module.exports = __webpack_public_path__ + "static/media/living room-03.36c25e7c.jpg";